
import { useEffect, useState } from 'react';
import { apiDomain, warName } from '../../../..';
import { getLabel } from '../../../../data/labels';
import Loader from '../../../../common/Loader';
import { useFetchCheckbetTicket } from '../../../fetchCheckbetTicket';
import { getConfiguration, getQueryStringVariable, isUKCombinationMaskEnabled, restoreTicketDataWithUkCombinations } from '../../../utils';
import Legend from '../Legend';
import MultipleBetsTicket from './MultipleBetsTicket';
import SingleBetTicket from './SingleBetTicket';
import SystemBetsTicket from './SystemBetsTicket';

function CheckBetLayout2(props) {
    const [data, setData] = useState(null);
    const [showLoader, setShowLoader] = useState(true);
    const conf = getConfiguration();
    const logoURL = `${apiDomain}/${warName}/content/images/customer-logo/${conf.logo}`;
    const ticketId =  getQueryStringVariable('ticketId') || getQueryStringVariable('ticket') || props.ticketId;
    const hideLogo = getQueryStringVariable('hideLogo') === 'true';
    
    //const [state] = useFetchCheckbetTicket(queryString.get('ticketId'), true, data && data.isLive);
    var isLive = false;
    if(data && data.live){
        isLive = true;
    }
    const [state] = useFetchCheckbetTicket(ticketId, true, isLive, isLive, false);

    useEffect(() => {
        if (process.env.REACT_APP_FRONTEND_VERSION === 'starcasino') {
            import('../starcasino.min.css');
        } else {
            import('../my-bets.min.css');
        }
    }, []);

    useEffect(() => {
        if (!state.isLoading && !state.isError) {
            if(state.data && isUKCombinationMaskEnabled() && state.data.type === 'systembets'){
            	restoreTicketDataWithUkCombinations(state.data, true);
            }
            setData(state.data);
            setShowLoader(false);
            if(props.onDataFetchComplete) {
                props.onDataFetchComplete(state.data);
            }
        }
    }, [state.data, state.isError, state.isLoading]);

    if (props.hideCheckbetLayout) {
        return null;
    }
     
    return (
        <div id="xs-my-bets-layout-2">
            {showLoader ?
                <Loader error={state.isError} positionRelative={props.isModal} />
                :
                <div id="cg-mybet-body" className="cg-mybet-section">
                    {!props.infoTicket && !hideLogo &&                	
                        <div id="checkbet-logo-container">
                            <img src={logoURL} alt="" />
                        </div>
                    }
                    {data == null ?
                        <div id="my-bets-container">
                            <span>{getLabel('checkbet.wrong_ticket_id', 'Ticket non esistente')}</span>
                        </div>
                        :
                        <>
                            <div id="my-bets-container" className="mb_2">
                                {data.type === 'singlebets' &&
                                    <SingleBetTicket key={data.id} ticket={data} infoTicket={props.infoTicket} obfuscateTicketId={props.obfuscateTicketId} />
                                }
                                {data.type === 'multibets' &&
                                    <MultipleBetsTicket key={data.id} ticket={data} infoTicket={props.infoTicket} obfuscateTicketId={props.obfuscateTicketId} />
                                }
                                {data.type === 'systembets' &&
                                    <SystemBetsTicket key={data.id} ticket={data} infoTicket={props.infoTicket} openCheckSystemBets={props.openCheckSystemBets} obfuscateTicketId={props.obfuscateTicketId} />
                                }
                            </div>
                            <Legend />
                            {props.infoTicket && !props.hideOperatorFunctions &&
                                <div className="checkbet-operator-functions">
                                    {conf.rs.pctk && window?.appConfig?.TERMINAL_AGENCY && 
                                        <div>
                                            <div className="checkbet-button ml-auto mr-auto my-bets-printer" onClick={() => { window.printTerminalCopy(data.id)}}>
                                                <i className="fas fa-print" />
                                            </div>
                                            <div className="checkbet-operator-functions-desc" >{getLabel('checkbet.print_copy')}</div>
                                        </div>
                                    }
                                    {data.reprintReceipt && window?.appConfig?.TERMINAL_AGENCY && 
                                        <div>
                                            <div className="checkbet-button ml-auto mr-auto my-bets-printer" onClick={() => { window.reprintTerminalTicket(data.id); props.close()}}>
                                                <i className="fas fa-print" />
                                            </div>
                                            <div className="checkbet-operator-functions-desc" >{getLabel('retail.operator_menu.form_button.reprint_receipt')}</div>
                                        </div>
                                    }
                                    <div id="retail-purchase-again">
                                        <div  className="checkbet-button ml-auto mr-auto my-bets-cart" onClick={() => { props.purchaseTicket(data.id, data.psv) } }>
                                            <i className="fas fa-solid fa-coins"></i>
                                        </div>
                                        <div className="checkbet-operator-functions-desc" >{getLabel('checkbet.purchase_again')}</div>
                                    </div>
                                    <div>
                                        <div className="checkbet-button ml-auto mr-auto my-bets-cart" onClick={() => { props.reloadTicketInCart(data.id, data.psv) } }>
                                            <i className="fas fa-cart-plus" />
                                        </div>
                                        <div className="checkbet-operator-functions-desc" >{getLabel('checkbet.reload_in_betslip')}</div>
                                    </div>
                                </div>
                            }
                        </>
                    }
                </div>
            }
        </div>
    );
}

export default CheckBetLayout2;